import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { StatisticsChartCardToolbar, StatisticsChartCardFullscreenAction } from './StatisticsChartCardActions';
import { CHART_CARD_SURFACE, getBoardChartCardClass, isBoardChartCardSurface } from './chartCard.js';

const PRESET_FULLSCREEN_TITLE = '全屏查看订单明细';

const StatisticsChartCardHeader = ({ surface = CHART_CARD_SURFACE.PRESET, meta, toolbar, headMainProps, title, onFullscreen }) => {
	const boardClass = getBoardChartCardClass(surface);
	const isPreset = surface === CHART_CARD_SURFACE.PRESET;
	const isBoard = isBoardChartCardSurface(surface);

	const resolvedMeta = meta ?? (isPreset && title ? <h3 className='statistics-pipeline-page__chart-title mb-0'>{title}</h3> : null);

	const resolvedToolbar =
		toolbar ??
		(isPreset && onFullscreen ? (
			<StatisticsChartCardToolbar>
				<StatisticsChartCardFullscreenAction onClick={onFullscreen} title={PRESET_FULLSCREEN_TITLE} />
			</StatisticsChartCardToolbar>
		) : null);

	if (!resolvedMeta && !resolvedToolbar) return null;

	if (isPreset) {
		return (
			<div className='statistics-pipeline-page__chart-head'>
				{resolvedMeta}
				{resolvedToolbar}
			</div>
		);
	}

	if (isBoard && boardClass) {
		const { className: headMainClassNameFromProps, ...restHeadMainProps } = headMainProps ?? {};
		const headMain = (
			<div className={classNames(boardClass.headMain, headMainClassNameFromProps)} {...restHeadMainProps}>
				{resolvedMeta ? <div className={boardClass.meta}>{resolvedMeta}</div> : null}
			</div>
		);

		const headInner = boardClass.head ? (
			<div className={boardClass.head}>
				{headMain}
				{resolvedToolbar}
			</div>
		) : (
			<>
				{headMain}
				{resolvedToolbar}
			</>
		);

		return <header className={boardClass.header}>{headInner}</header>;
	}

	return null;
};

StatisticsChartCardHeader.propTypes = {
	surface: PropTypes.oneOf(Object.values(CHART_CARD_SURFACE)),
	meta: PropTypes.node,
	toolbar: PropTypes.node,
	headMainProps: PropTypes.object,
	title: PropTypes.string,
	onFullscreen: PropTypes.func,
};

export default StatisticsChartCardHeader;
